import { render, staticRenderFns } from "./user-popup.vue?vue&type=template&id=2a0371b9"
import script from "./user-popup.vue?vue&type=script&lang=js"
export * from "./user-popup.vue?vue&type=script&lang=js"
import style0 from "./user-popup.vue?vue&type=style&index=0&id=2a0371b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports